
<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhhqbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'后勤服务中心'"></detailBread>
        <div  class="container">
            <div class="page-title">
                后勤服务中心
            </div>
            <div class="page-content">
                <img src="../../../static/images/zhhq-hqfwzx-01.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '后勤服务中心', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '后勤服务中心,校园智慧后勤管理系统,后勤管理软件系统,高校后勤管理系统软件'
        },
        {
            name: 'description',
            content: '后勤服务中心,校园智慧后勤管理系统,后勤管理软件系统,高校后勤管理系统软件'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'1',
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/old/hqfwzx.vue